import { render, staticRenderFns } from "./mcstatus.vue?vue&type=template&id=1b9a1653&"
import script from "./mcstatus.vue?vue&type=script&lang=js&"
export * from "./mcstatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports